import React from "react";
import * as R from "ramda";
import styled from "styled-components/macro";
import { Radio, Modal, Spin } from "antd";

const SpinWrapper = styled.div`
  margin: 50px;
  display: flex;
  justify-content: center;
`;

const StyledModal = styled(Modal)`
  .ant-radio-wrapper {
    display: block;
    line-height: 36px;
  }
`;

export default function SelectCalendarModal({
  t,
  calendars,
  onSelectCalendar,
  fetchingCalendars,
  updatingCalendar,
  onClose
}) {
  const [selectedCalendarId, setSelectedCalendarId] = React.useState();

  React.useEffect(
    () => {
      const firstCalendarId = R.path([0, "calendar_id"], calendars);

      if (firstCalendarId) {
        // Default to first calendar
        setSelectedCalendarId(firstCalendarId);
      }
    },
    [calendars]
  );

  return (
    <StyledModal
      visible={true}
      title={t("user:calendar.connectCalendar")}
      wrapProps={{ "data-test": "select-calendar-modal" }}
      cancelText={t("global:cancel")}
      onOk={() => {
        onSelectCalendar(selectedCalendarId);
      }}
      okText={t("user:calendar.connect")}
      okButtonProps={{
        disabled: !selectedCalendarId || fetchingCalendars,
        loading: updatingCalendar,
        "data-test": "select-calendar-btn"
      }}
      onCancel={onClose}
    >
      {fetchingCalendars || updatingCalendar ? (
        <SpinWrapper>
          <Spin />
        </SpinWrapper>
      ) : (
        <>
          <p>{t("user:calendar.selectCalendarModalIntro")}</p>
          <Radio.Group
            value={selectedCalendarId}
            onChange={event => setSelectedCalendarId(event.target.value)}
          >
            {calendars &&
              calendars.map(calendar => (
                <Radio
                  data-test={`calendar-${calendar.calendar_id}`}
                  value={calendar.calendar_id}
                  key={calendar.calendar_id}
                >
                  {calendar.calendar_name}
                  {calendar.calendar_name !== calendar.profile_name &&
                    ` - ${calendar.profile_name}`}
                </Radio>
              ))}
          </Radio.Group>
        </>
      )}
    </StyledModal>
  );
}
